import LftArrowLeftIcon from '@lift/assets/dist/assets/globals/icons/arrow_left';
import LftIconButton from '@lift/design-system-react-web/dist/components/LftIconButton';
import LftTypography from '@lift/design-system-react-web/dist/components/LftTypography';
import { useCallback, useMemo } from 'react';
import { BotaoVoltar } from '../botao-voltar/botao-voltar.component';
import S from './header.styles';
import { HeaderProps } from './header.types';

export const Header: React.FC<HeaderProps> = ({
  curso,
  exibirLabelVoltar,
  actionVoltar,
  aside,
}) => {
  const clickVoltar = useCallback(() => {
    // Ao sair da modal, deve-se liberar o scroll novamente para o usuário
    document.getElementsByTagName('body')[0].style.overflow = 'auto';

    actionVoltar();
  }, [actionVoltar]);

  const Lateral = useCallback(
    () => (
      <S.Lateral>
        {exibirLabelVoltar ? (
          <BotaoVoltar
            semMargem={true}
            onClick={clickVoltar}
            ariaLabel="Voltar para a lista conteúdos digitais"
            dataElement="button_voltar"
          />
        ) : (
          <LftIconButton
            icon={LftArrowLeftIcon}
            size="lg"
            lftClick={clickVoltar}
            ariaLabel="Voltar para a lista conteúdos digitais"
            dataElement="voltar"
            dataTestId="btn-voltar"
          />
        )}
      </S.Lateral>
    ),
    [clickVoltar, exibirLabelVoltar],
  );

  return useMemo(
    () => (
      <S.Header
        data-section="section_menu-superior-conteudo-academico"
        data-testid="section_conteudo-cursos-complementares"
      >
        <Lateral />
        <S.TituloWrapper>
          <LftTypography component="paragraph" aria-label={curso.titulo}>
            <S.TextoTruncado>{curso.titulo}</S.TextoTruncado>
          </LftTypography>
        </S.TituloWrapper>

        <S.Lateral>{aside}</S.Lateral>
      </S.Header>
    ),
    [Lateral, aside, curso.titulo],
  );
};
